import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
// const userID = cookies.get("USER_ID");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

export const getInventoryService = async (office: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/inventory/${office}`);
  return res;
};

export const getCompletedBundlesService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/bundles/completed`);
  return res;
};

export const putRezeroInventoryService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.put(`${apiURL}/metalstrading/api/inventory/rezero/${payload.inventoryID}`, payload);
  return res;
};

export const putUpdateInventoryService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  payload.updatedByUserID = userID;
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.put(`${apiURL}/metalstrading/api/inventory/update/${payload.inventoryID}`, payload);
  return res;
};

export const putMoveInventoryService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  payload.updatedByUserID = userID;
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.put(`${apiURL}/metalstrading/api/inventory/move`, payload);
  return res;
};
